import { createContext, useContext } from 'react';
import type { InstanceAPIs } from '../host/contracts';
import type { useRealApiReadinessGate } from '../host/config/connection';
import type { useWorkspaceLocationSelection } from './projects/workspace-location.js';
import type { createHostViewModel } from '../projection/workspace.js';
import type { useModeManagement } from './capabilities/useModeManagement.js';
import type { useSkillManagement } from './capabilities/useSkillManagement.js';

export interface HostChatView {
  workspaceLocation: ReturnType<typeof useWorkspaceLocationSelection>;
  viewModel: ReturnType<typeof createHostViewModel>;
  realApi: InstanceAPIs;
  apiReadinessGate: ReturnType<typeof useRealApiReadinessGate>;
  blockedApiError: Error | null;
  modeManagement: ReturnType<typeof useModeManagement>;
  skillManagement: ReturnType<typeof useSkillManagement>;
}
export const HostChatContext = createContext<HostChatView | null>(null);
export const useApplicationChat = (): HostChatView => {
  const value = useContext(HostChatContext);
  if (!value) throw new Error('Xiaocai chat surface requires its host provider');
  return value;
};

/** UI receives presentation and actions, never the application adapter bundle. */
export const useHostChat = (): Omit<HostChatView, 'realApi'> => {
  const { workspaceLocation, viewModel, apiReadinessGate, blockedApiError, modeManagement, skillManagement } = useApplicationChat();
  return { workspaceLocation, viewModel, apiReadinessGate, blockedApiError, modeManagement, skillManagement };
};
